import type { ReportData } from '@/types/report';

import { INITIAL_FORM_DATA } from '../constants';

export const normalizeReportData = (report?: Partial<ReportData> | null): ReportData => {
    const initialCustomizations = (INITIAL_FORM_DATA.customizations ??
        {}) as ReportData['customizations'];
    const reportCustomizations = report?.customizations ?? {};

    return {
        ...(INITIAL_FORM_DATA as ReportData),
        ...report,
        section_order: report?.section_order ?? INITIAL_FORM_DATA.section_order,
        custom_sections: report?.custom_sections ?? INITIAL_FORM_DATA.custom_sections,
        customizations: {
            ...initialCustomizations,
            ...reportCustomizations,
            colors: {
                ...initialCustomizations.colors,
                ...(reportCustomizations.colors ?? {}),
            } as NonNullable<ReportData['customizations']['colors']>,
            header: {
                ...initialCustomizations.header,
                ...(reportCustomizations.header ?? {}),
            } as NonNullable<ReportData['customizations']['header']>,
            footer: {
                ...initialCustomizations.footer,
                ...(reportCustomizations.footer ?? {}),
            } as NonNullable<ReportData['customizations']['footer']>,
            font: {
                ...initialCustomizations.font,
                ...(reportCustomizations.font ?? {}),
            } as NonNullable<ReportData['customizations']['font']>,
            table: {
                ...initialCustomizations.table,
                ...(reportCustomizations.table ?? {}),
            } as NonNullable<ReportData['customizations']['table']>,
            divider: {
                ...initialCustomizations.divider,
                ...(reportCustomizations.divider ?? {}),
            } as NonNullable<ReportData['customizations']['divider']>,
        },
    };
};
